import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

const API_ENDPOINT = 'api/';

@Injectable({
  providedIn: 'root',
})
export class ApiProductService {
  public productModalOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public products: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public categories: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  /**
   * Constructor
   *
   * @param {HttpClient} http
   */
  public constructor(private http: HttpClient) {
  }

  /**
   * Get all the available categories
   * 
   * @returns Observable<any>
   */
  public getCategories(): Observable<any> {
    return this.http.get(API_ENDPOINT + 'category/get/all')
    .pipe(
      map((response: any) => {
        this.categories.next(response.categories);
        return response.categories;
      }),
      catchError((error) => {
          return throwError(error);
        },
      ),
    );
  }

  /**
   * Get all the available products
   *
   * @return Observable<any>
   */
   public getProducts(): Observable<any> {
    return this.http.get(API_ENDPOINT + 'products/get/all')
    .pipe(
      map((response: any) => {
        this.products.next(response.products)
        return response.products;
      }),
      catchError((error) => {
          return throwError(error);
        },
      ),
    );
  }

  /**
   * Get all the available products
   *
   * @return Observable<any>
   */
   public getProduct(productId: string|number): Observable<any> {
    if(this.products.value.length > 0) {
      let productFound = this.products.value.find((product) => {return product.id == productId});
      if(productFound != null) {
        let relatedProducts = this.products.value.filter((product) => {
          return product.id != productFound.id && product.category.id === productFound.category.id
        }).slice(0, 6);
        let objToReturn = {
            product: productFound,
            relatedProducts
        }
        return of(objToReturn);
      }
    }
    
    return this.http.get(API_ENDPOINT + 'products/get/' + productId)
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error) => {
          return throwError(error);
        },
      ),
    );
  }
}
